document.addEventListener('DOMContentLoaded', () => {
    const sliders = document.querySelectorAll('[data-doctor-experts-slider]');

    if (!sliders.length) return;

    sliders.forEach((slider) => {
        if (typeof Swiper === 'undefined') {
            console.warn('Swiper is not loaded');
            return;
        }

        const section = slider.closest('.doctor-experts');
        const prevButton = section.querySelector('.doctor-experts__arrow--prev');
        const nextButton = section.querySelector('.doctor-experts__arrow--next');
        const paginationEl = section.querySelector('[data-slider-pagination]');
        const currentEl = section.querySelector('[data-slider-current]');
        const totalEl = section.querySelector('[data-slider-total]');
        const totalSlides = Number(slider.dataset.slidesCount || 0);

        const formatNumber = (num) => String(num).padStart(2, '0');

        const swiper = new Swiper(slider, {
            speed: 700,
            spaceBetween: 20,
            slidesPerView: 'auto',
            watchOverflow: true,
            navigation: {
                prevEl: prevButton,
                nextEl: nextButton
            },
            pagination: {
                el: paginationEl,
                clickable: true
            },
            breakpoints: {
                768: {
                    slidesPerView: 2,
                    spaceBetween: 20
                },
                1200: {
                    slidesPerView: 3,
                    spaceBetween: 20
                }
            },
            on: {
                init(swiperInstance) {
                    updateCounter(swiperInstance);
                },
                slideChange(swiperInstance) {
                    updateCounter(swiperInstance);
                }
            }
        });

        function updateCounter(swiperInstance) {
            if (currentEl) {
                currentEl.textContent = formatNumber(swiperInstance.realIndex + 1);
            }

            if (totalEl) {
                totalEl.textContent = totalSlides;
            }
        }
    });
});